import React from 'react'
//import {withRouter} from 'react-router';
import { Route, Switch } from 'react-router-dom';

import Dashboard from './../components/Dashboard';
import NotFound from './../components/notfound/NotFound';
import TermsAndConditions from './../components/TermsAndConditions';
import ReconfirmTC from './../components/ReconfirmTC';
import Logout from './../components/Logout';
class Content extends React.Component {
  render() {
    return (
      <div className="row content-area">
        <Switch>
          <Route path={window.env.appcontext + "/termandcondition"} component={TermsAndConditions} exact />
          <Route path={window.env.appcontext + "/reconfirmTC"} component={ReconfirmTC} exact />
          <Route path={window.env.appcontext + "/dashboard/:appType?"} component={Dashboard} exact />
          <Route path={window.env.appcontext + "/logout"} component={Logout} exact />
          <Route path={window.env.appcontext + "/"} component={Dashboard} exact />          
          <Route component={NotFound} />
        </Switch>
      </div>
    );
  }
}

export default Content;